import React from 'react';
import Hero from './components/IQAC/aqar/Hero';
import Main from './components/IQAC/aqar/Main';

const IqacAqarReports = () => {
  return (
    <div>
        <Hero />
        <Main />
    </div>
  )
}

export default IqacAqarReports;